/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _menu = __webpack_require__(1);

	var _menu2 = _interopRequireDefault(_menu);

	var _sliders = __webpack_require__(3);

	var _sliders2 = _interopRequireDefault(_sliders);

	var _stickyHeader = __webpack_require__(4);

	var _stickyHeader2 = _interopRequireDefault(_stickyHeader);

	var _buttons = __webpack_require__(5);

	var _buttons2 = _interopRequireDefault(_buttons);

	var _compareSlider = __webpack_require__(6);

	var _compareSlider2 = _interopRequireDefault(_compareSlider);

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	var _responsive = __webpack_require__(7);

	var _responsive2 = _interopRequireDefault(_responsive);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	jQuery(function () {
		// Site Menu
		_menu2.default.init();

		// Slick Slider
		_sliders2.default.init();

		// Sticky Header
		_stickyHeader2.default.init();

		// Buttons
		_buttons2.default.init();

		// Compare Slider
		_compareSlider2.default.init();

		// Plugins call
		_global2.default.pluginsCall();

		// Responsive
		_responsive2.default.init();

		// Form Submit
		_global2.default.formSubmit();
	});

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict';
	var Menu = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$domMenuBtn: $('.js-menu-btn'),
		$domMenuWrap: $('.js-menu-container'),
		$domMenuNav: $('.js-main-nav'),
		$domMenuHasSub: $('.menu-item-has-children'),
		$domFormHolder: $('.header-form__container'),
		classOpen: 'open',
		classOpenMenu: 'menu-open',

		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			// functions
			function closeNav() {
				Menu.$domMenuWrap.removeClass(Menu.classOpen);
				Menu.$domMenuBtn.removeClass(Menu.classOpen);
				Menu.$domMenuNav.removeClass(Menu.classOpen);
				_global2.default.$domBody.removeClass(Menu.classOpenMenu);
			}

			this.$domMenuHasSub.each(function (i, el) {
				$(el).find('> a').after('<span class="sub-icon font-plus-circle" data-open-sub></span>');
			});

			// bind events
			this.$domMenuBtn.on('click', function (e) {
				e.preventDefault();
				Menu.$domMenuBtn.toggleClass(Menu.classOpen);
				Menu.$domMenuWrap.toggleClass(Menu.classOpen);
				Menu.$domMenuNav.toggleClass(Menu.classOpen);
				_global2.default.$domBody.toggleClass(Menu.classOpenMenu);
				if (!Menu.$domMenuBtn.hasClass(Menu.classOpen)) {
					Menu.$domFormHolder.removeClass(Menu.classOpen);
					$('.site').removeClass('form-submited');
				}

				if ($('.site').hasClass('form-submited')) {
					setTimeout(function () {
						$('.site').removeClass('form-submited');
					}, 300);
				}
			});

			this.$domMenuNav.on('click', '[data-open-sub]', function () {
				$(this).toggleClass('open').siblings('.sub-menu').slideToggle();
			});

			// $('.menu-item-has-children').on('ho')
			if (window.innerWidth > 1024) {
				$('.menu-item-has-children').hover(function () {
					$(this).find('> .sub-menu').slideToggle().addClass('opened');
				}, function () {
					var _this = this;

					$(this).find('> .sub-menu').slideToggle();
					setTimeout(function () {
						$(_this).find('> .sub-menu').removeClass('opened');
					}, 500);
				});
			}

			// Global.functions.clickOutsideContainer(this.$domMenuNav, this.$domMenuNav.children('ul'), this.$domMenuBtn, closeNav);

			_global2.default.functions.escKey(closeNav);
		}
	};

	exports.default = Menu;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();

	'use strict';
	var Global = {
		$domWindow: $(window),
		$domDoc: $(document),
		$domBody: $('body'),

		varsWindowWidth: window.innerWidth,

		functions: {
			escKey: function escKey(callback) {
				Global.$domDoc.on('keyup', function (e) {
					if (e.keyCode === 27) {
						callback();
					}
				});
			},

			clickOutsideContainer: function clickOutsideContainer(selector, container, closeBtn, callback) {
				selector.on('mouseup', function (e) {
					e.preventDefault();
					if (!container.is(e.target) && container.has(e.target).length === 0 && !closeBtn.is(e.target)) {
						callback();
					}
				});
			}
		},

		pluginsCall: function pluginsCall() {
			// AOS Animations call
			setTimeout(function () {
				AOS.init({
					disable: 'mobile',
					duration: 800,
					once: true
				});
			}, 200);

			// Select2
			$('.wpcf7-select').select2({
				minimumResultsForSearch: 10,
				width: 'style'
			});
		},

		formSubmit: function formSubmit() {
			var wpcf7Elm = document.querySelector('.wpcf7');

			if (wpcf7Elm) {
				wpcf7Elm.addEventListener('wpcf7mailsent', function (e) {
					var _self = $(e.currentTarget);

					_self.parents('.site').addClass('form-submited');
				}, false);
			}
		}
	};

	exports.default = Global;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();

	'use strict';
	var Sliders = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$portfolioSlider: $('.js-portfolio-slider'),
		$portfolioImage: $('.portfolio-slider__img'),

		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			var _this = this;

			this.$portfolioSlider.on('init', function (event, slick) {
				var initSlide = $(this).find('.slick-current');
				var color = initSlide.attr('data-slider-color');
				var slickButtonActive = $('.slick-dots .slick-active button');

				if (color) {
					slickButtonActive.css('color', color);
				} else {
					slickButtonActive.css('color', '#7ed321');
				}

				$(this).addClass('show');
			});

			// slider
			this.$portfolioSlider.slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				speed: 200,
				arrows: false,
				dots: true,
				fade: true,
				useCSS: false,
				// cssEase: 'cubic-bezier(.88,-0.55, .57, 1)',

				responsive: [{
					breakpoint: 991,
					settings: {
						slidesToShow: 1
					}
				}, {
					breakpoint: 767,
					settings: {
						slidesToShow: 1
					}
				}]
			});

			if ($(window).width() > 1024) {
				// Change overlay url
				this.$portfolioSlider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
					var slickButton = $('.slick-dots button');
					var nextImage = $('[data-slick-index="' + nextSlide + '"]');
					var curSlide = $('[data-slick-index="' + currentSlide + '"]');
					var bg = nextImage.attr('data-bg');
					var bgc = nextImage.attr('data-bgc');
					var overlayBg = curSlide.find('.portfolio-slider__img-bg-overlay-inner');

					slickButton.prop('disabled', true);
					overlayBg.css('background-image', 'url(' + bg);
					overlayBg.css('background-color', bgc);
				});
			}

			this.sliderOverlaySize();

			$(window).on('resize', function () {
				setTimeout(function () {
					_this.sliderOverlaySize();
				}, 500);
			});

			// Change dots color on each slide
			this.$portfolioSlider.on('afterChange', function (event, slick, currentSlide, nextSlide) {
				var slide = $('[data-slick-index="' + currentSlide + '"]');
				var color = slide.attr('data-slider-color');
				var slickButton = $('.slick-dots li:not(.slick-active) button');
				var slickButtonActive = $('.slick-dots .slick-active button');

				setTimeout(function () {
					slickButton.prop('disabled', false);
				}, 1500);

				slickButton.css('color', '#fff');
				if (color) {
					slickButtonActive.css('color', color);
				} else {
					slickButtonActive.css('color', '#7ed321');
				}
			});

			if ($(window).width() <= 1024) {
				this.$portfolioImage.each(function (i, el) {
					var parent = $(el).parent().find('.portfolio-slider__title');
					parent.after(el);
				});
			}
		},

		sliderOverlaySize: function sliderOverlaySize() {
			var sliderWidth = $('.portfolio-slider__img-holder').innerWidth();
			$('.portfolio-slider__img-bg-overlay-inner').each(function (i, el) {
				$(el).css('width', sliderWidth);
			});
		}
	};

	exports.default = Sliders;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();

	'use strict';
	var StickyHeader = {

		$header: $('[data-header]'),
		$main: $('.main'),
		stickyClass: 'is-sticky',

		init: function init() {
			this.checkScrolling();
		},

		checkScrolling: function checkScrolling() {
			var _this = this;

			$(window).scroll(function () {
				if ($(window).scrollTop() > 1) {
					_this.$header.addClass(_this.stickyClass);
				} else {
					_this.$header.removeClass(_this.stickyClass);
				}
			});
		}
	};

	exports.default = StickyHeader;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();

	'use strict';
	var Buttons = {

		$headerFormBtn: $('.js-header-form-btn'),
		$headerForm: $('.header-form__container'),
		classOpen: 'open',
		attrOpenText: 'data-open-text',
		attrCloseText: 'data-close-text',

		init: function init() {
			var _self = this;
			var openText = this.$headerFormBtn.attr(this.attrOpenText);
			var closeText = this.$headerFormBtn.attr(this.attrCloseText);

			this.$headerFormBtn.on('click', function (e) {
				e.preventDefault();

				var text = $(this).text();

				_self.$headerForm.toggleClass(_self.classOpen);

				if (window.innerWidth > 992) {
					$(this).text(text === openText ? closeText : openText);
				}
			});
		}

	};

	exports.default = Buttons;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();

	'use strict';
	var compareSlider = {

		init: function init() {
			// functions
			var $dom = {
				compare: $('[data-compare]'),
				compareLeft: '[data-compare-left]',
				compareRight: '[data-compare-right]'
			};

			if (window.innerWidth <= 1024) {
				if ($dom.compare.length >= 1) {
					$dom.compare.on('touchmove', function (e) {
						var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
						var w = touch.clientX - $(this).offset().left;

						$(this).find($dom.compareLeft).width(w);
						$(this).find($dom.compareRight).width($(this).width() - w);
					});

					$dom.compare.on('touchmove', function (e) {
						var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
						var i = touch.clientX - $(this).offset().left;

						$(this).find($dom.compareLeft).width(i);
						$(this).find($dom.compareRight).width($(this).width() - i);
					});
				}
			} else {
				$dom.compare.mousemove(function (e) {
					var w = e.pageX - $(this).offset().left;
					$(this).find($dom.compareLeft).width(w);
					$(this).find($dom.compareRight).width($(this).width() - w);
				});
				$dom.compare.mousemove(function (e) {
					var i = e.pageX - $(this).offset().left;
					$(this).find($dom.compareLeft).width(i), $(this).find($dom.compareRight).width($(this).width() - i);
				});
			}
		}
	};

	exports.default = compareSlider;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();

	'use strict';
	var Responsive = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$promeTitle: $('.js-portfolio-promo-title'),
		$promoTop: '.js-portfolio-promo-top',
		$serviceTitles: $('.js-service-item__text-top'),
		$portfolioLogo: $('.portfolio-item__logo'),

		classPortfolioPromoTop: '.portfolio-promo',
		classPortfolioPromoImg: '.js-portfolio-promo-top .portfolio-promo__img',
		classServiceItem: '.service-item',
		classServiceImg: '.service-item__img',
		classPortfolioItem: '.portfolio-item',
		classPortfoiloWrap: '.wrap-small',

		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			var _this = this;

			if ($(window).width() <= 1024) {
				// portfolio promo
				if (this.$promeTitle.length >= 1) {
					this.$promeTitle.each(function (i, el) {
						var top = $(el).parents(_this.classPortfolioPromoTop).find(Responsive.$promoTop);
						$(el).insertBefore(_this.classPortfolioPromoImg);
					});
				}

				// Services
				if (this.$serviceTitles.length >= 1) {
					this.$serviceTitles.each(function (i, el) {
						var top = $(el).parents(_this.classServiceItem).find(_this.classServiceImg);
						$(el).prependTo(top);
					});
				}

				// Portfolio
				if (this.$portfolioLogo.length >= 1) {
					this.$portfolioLogo.each(function (i, el) {
						var top = $(el).parents(_this.classPortfolioItem).find(_this.classPortfoiloWrap);
						$(el).prependTo(top);
					});
				}
			}
		}
	};

	exports.default = Responsive;

/***/ })
/******/ ]);